import * as types from './types';

const getFormValues = payload => {
  const module = payload.module ? `/MODULE_${payload.module}/${payload.postingId}` : '';
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicador',
      path: `/publicador/api/v1/postings/${payload.step}${module}`,
      method: 'GET'
    }
  };
};

const getLatLngData = (lat = null, lng = null) => ({
  type: types.GET_COORDINATES,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/locations/geopoint?lat=${lat}&lng=${lng}`,
    coordinates: { lat, lng },
    method: 'GET'
  }
});

const getLocation = (location, zone) => ({
  type: types.GET_LOCATION,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/locations/${location}/childrens`,
    method: 'GET',
    locationName: [zone]
  }
});

const getCep = CEP => ({
  type: types.GET_CEP,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/locations/validate?cep=${CEP}`,
    method: 'GET'
  }
});

const setAddress = payload => ({
  type: types.SET_ADDRESS,
  payload
});

const setCep = payload => ({
  type: types.SET_CEP,
  payload
});

const setAddressComplement = payload => ({
  type: types.SET_ADDRESS_COMPLEMENT,
  payload
});

const setSelectedProvince = (data, reset) => ({
  type: types.SET_SELECTED_PROVINCE,
  payload: {
    data,
    reset
  }
});

const setSelectedCity = (data, reset) => ({
  type: types.SET_SELECTED_CITY,
  payload: {
    data,
    reset
  }
});

const setSelectedDistrict = (data, reset) => ({
  type: types.SET_SELECTED_DISTRICT,
  payload: {
    data,
    reset
  }
});

const setSelectedSubDistrict = payload => ({
  type: types.SET_SELECTED_SUBDISTRICT,
  payload
});

const setVisibility = payload => ({
  type: types.SET_VISIBILITY,
  payload
});

const resetValues = () => ({
  type: types.RESET_VALUES
});

const setIsEdited = payload => ({
  type: types.SET_EDITED,
  payload
});

const saveStep1Module2 = payload => ({
  type: types.SAVE_STEP1_MODULE_2,
  payload
});

const resetInfo = () => ({
  type: types.RESET_INFO
});

const setEditValues = payload => ({
  type: types.SET_EDIT_VALUES,
  payload
});

const setCoordinates = payload => ({
  type: types.SET_COORDINATES,
  payload
});

export {
  getLatLngData,
  getLocation,
  setAddress,
  setSelectedProvince,
  setSelectedCity,
  setSelectedDistrict,
  setSelectedSubDistrict,
  setVisibility,
  resetValues,
  setIsEdited,
  saveStep1Module2,
  resetInfo,
  setEditValues,
  getFormValues,
  setCoordinates,
  getCep,
  setCep,
  setAddressComplement
};
